import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from "axios";
import baseMessages from '@/locales/en.json';
import consentMessages from '@/locales_consent/en.consent.json';

const messages = { ...baseMessages, ...consentMessages };

Vue.use(VueI18n);

export const i18n = new VueI18n({
    locale: 'en', // locale: set the default language
    fallbackLocale: 'en',
    messages,
    silentTranslationWarn: true
});

const loadedLanguages = []

function setI18nLanguage (lang) {
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export async function loadLanguageAsync(currentLang) {
    // If the language was already loaded
    if (loadedLanguages.includes(currentLang)) {
        return Promise.resolve(setI18nLanguage(currentLang))
    }
    // If the language hasn't been loaded yet
    let messages = null;
    const [base, consent] = await Promise.all([
        import(/* webpackChunkName: "i18n-locale" */ `@/locales/${currentLang}.json`),
        import(/* webpackChunkName: "i18n-consent" */ `@/locales_consent/${currentLang}.consent.json`).catch(() => ({ default: {} }))
    ]);
    messages = { default: { ...base.default, ...consent.default } };
    if (messages != null) {
        i18n.setLocaleMessage(currentLang, messages.default)
        loadedLanguages.push(currentLang)
        return setI18nLanguage(currentLang)
    }
}